$(document).ready(function () {
  //На странице поиска вставить изображение в блок
  let timerId = setTimeout(function tick() {
      let priceElements = $('#snize_results .snize-price-with-discount');
      
      priceElements.each((index, item) => {
        if ($(item).find('._special_value').length > 0) return;
        
        const price = $(item).html();
        $(item).html(`<div class="exemptify_price _special_value">${price}</div><img class="_special_img" src="//www.meadowweb.com/cdn/shop/t/43/assets/sale_big.png?v=99836056013838181181716316050" />`);
      });

      timerId = setTimeout(tick, 100);
  }, 100);
});

  
